/*
 * SPDX-FileCopyrightText: © 2024 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

@import url('../shared.css');

:host {
  display: contents;
}

.qds-table-row {
  border-block-end: var(--qds-list-border-width) solid
    var(--qds-theme-divider-standard);
  box-sizing: border-box;
}
